// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"91":"6afd26be","127":"8ae8cd1b","284":"74cb4041","685":"f23966fe","787":"185c930c","846":"d47c8db9","936":"446c751e"}[chunkId] + ".chunk.js";
};